module.exports = __webpack_public_path__ + "img/sparkling-water-img.b3886f62.jpg";